import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import authStore from './store/auth'
import './assets/styles/main.css'

// Font Awesome (you'll need to install it)
import '@fortawesome/fontawesome-free/css/all.min.css'

// Toast Notifications
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// Motion and Animation Libraries
import { MotionPlugin } from '@vueuse/motion'

const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

authStore.checkAuthStatus().catch(() => {})

createApp(App)
  .use(router)
  .use(store)
  .use(Toast, toastOptions)
  .use(MotionPlugin)
  .mount('#app')